
<div class="row">
  <div class="col-11 pl-0 pr-0">
    @if (title && options.enableHtml) {
      <div [class]="options.titleClass" role="alert" aria-live="polite" [attr.aria-label]="title">
        {{ title }}
      </div>
    }
    @if (message && options.enableHtml && !this.showFullMessage) {
      <div
        role="alert" aria-live="polite" [class]="options.messageClass" [attr.aria-label]="message">
        {{ this.manipulateWithErrorText(message) }}
      </div>
    }

    @if (message && options.enableHtml && this.showFullMessage) {
      <div
        role="alert" aria-live="polite" [class]="options.messageClass" [attr.aria-label]="message">
        {{ message }}
      </div>
    }

    @if (message && message.length > 110 && options.enableHtml) {
      <div class="font-weight-bold d-flex justify-content-between">
        <button  class="btn btn-link pl-0" type="button" (click)="showMessageDetails()">
          @if (!this.showFullMessage) {
            <span>Prikaži podrobnosti</span>
          }
          @if (this.showFullMessage) {
            <span>Skrij podrobnosti</span>
          }
        </button>
        <button  class="btn btn-link pl-0" type="button" (click)="copyToClipboard(message)">
          @if (!this.isCopiedToClipboard) {
            <span> <i class="fas fa-paste" style="font-size: 18px;" ></i> Kopiraj opis napake</span>
          }
          @if (this.isCopiedToClipboard) {
            <span><i class="fas fa-paste" style="color: #c6c6c7; font-size: 18px;" ></i> Opis skopiran v odložišče</span>
          }
        </button>
      </div>
    }
  </div>
  <div class="col-1 text-right">
    @if (options.closeButton) {
      <i class="fas fa-times-circle" style="font-size: 25px;" (click)="remove()"></i>
    }
  </div>
</div>
